import { useAuth } from "@mindlercare/auth-ui";
import { RolesEnum } from "@mindlercare/schema";
import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { useMindlerApi } from "api/apiv2";
import type { User } from "core/types";

export const useUserHasRole = (role: RolesEnum | RolesEnum[]) => {
  const { roles } = useAuth();
  const targets = Array.isArray(role) ? role : [role];
  return !!roles?.some(({ name }) => targets.includes(name));
};

export const useCurrentUser = () => {
  const { isLoggedIn } = useAuth();
  const api = useMindlerApi();
  const { data, isLoading } = useQuery(
    api.users.getCurrentUser.queryOptions(undefined, {
      enabled: isLoggedIn,
      staleTime: 5 * 60 * 1000,
    }),
  );
  return { user: (data as User | undefined) ?? null, isLoading };
};
